import './fourthdiv.css';
import IMAGES from '../../../images/images';
import GitHubCalendar from 'react-github-calendar';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

// import "swiper/css";
// import "swiper/css/zoom";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/zoom";
import SwiperCore, {
    Zoom,Pagination,Mousewheel,Keyboard, Autoplay, EffectFade 
  } from 'swiper';
import { certSlider } from '../../../data';

SwiperCore.use([Zoom,Pagination,Keyboard,Autoplay,EffectFade, Mousewheel]);


export default function FourthDiv() {
    return (
        <div className="aboutCode">
            <div className="aboutCode__git">
                <img src={IMAGES.github_label} alt="" />
                <GitHubCalendar username="ArcOmotola" />
            </div>
            
            <div className="aboutWork__box2">
                <div className="aboutWork__certWrapper">
                    <div className="certTitle">
                        <h4>Certifications</h4>
                    </div>
                    
                    
                    <Swiper
                    spaceBetween={0} 
                    effect={'fade'} 
                    // pagination={{ "clickable": true}}
                    autoplay={{"delay": 3000, "disableOnInteraction": false}}
                    zoom={true}
                    className="archi__imageSliderWrapper"
                    >
                        {certSlider.map((d) => (
                            <SwiperSlide className="cert__slider">
                            <div class="swiper-zoom-container">
                                <img src={d.img} alt="" />
                            </div>
                            </SwiperSlide>
                        ))}

                    </Swiper>
                    
                </div>
            </div>
        </div>
    )
}